import { render, staticRenderFns } from "./LinkedTaskColumn.vue?vue&type=template&id=ebadc1ea&v-slot=props&"
import script from "./LinkedTaskColumn.vue?vue&type=script&lang=js&"
export * from "./LinkedTaskColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports